// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3FBg9","large":"styles_large__G64kD"};